import React, { memo, useEffect } from "react";
import CdnImage from "../cdnImage/cdnImage";
const configurationManager = require("../../utils/config/configurationManager");
const arrayUtil = require("../../utils/array/arrayUtil");
const completeUrl = `/screenSaver.json`;
let screenSaver = await fetch(completeUrl, { cache: "no-store" });
screenSaver = await screenSaver.json();

const cloudName = configurationManager.getConfig().cdnAppCloudName;

const ScreenSaver = () => {
     const imagesSrc = Array.isArray(screenSaver.screenSaver) ? screenSaver.screenSaver : [];
     arrayUtil.shuffle(imagesSrc);

     useEffect(() => {
          let intervalId;

          const screenSaver = document.querySelector(".screen-saver");
          const screenSaverSlider = screenSaver.querySelector(".screen-saver-slider");
          const screenSaverSlides = screenSaverSlider.querySelectorAll(".screen-saver-slide");

          const mod = (n, m) => ((n % m) + m) % m;

          const animation = 500;
          const pause = 10000;

          let totalSlides = screenSaverSlides.length;
          let currentSlideIdx = 0;

          if (totalSlides < 2) return;

          const anim = (ms = animation) => {
               const cMod = mod(currentSlideIdx, totalSlides);

               screenSaverSlider.style.transitionDuration = `${ms}ms`;
               screenSaverSlider.style.transform = `translateX(${(-currentSlideIdx - 1) * 100}%)`;

               screenSaverSlides.forEach((elSlide, i) => elSlide.classList.toggle("is-active", cMod === i));
          };

          const next = () => {
               if (currentSlideIdx >= totalSlides) return;
               currentSlideIdx += 1;
               anim();
          };

          screenSaverSlider.addEventListener("transitionend", () => {
               if (currentSlideIdx <= -1) currentSlideIdx = totalSlides - 1;
               if (currentSlideIdx >= totalSlides) currentSlideIdx = 0;
               anim(0);
          });

          screenSaverSlider.prepend(screenSaverSlides[totalSlides - 1].cloneNode(true));
          screenSaverSlider.append(screenSaverSlides[0].cloneNode(true));

          anim(0);

          intervalId = setInterval(next, pause + animation);

          return () => {
               clearInterval(intervalId);
          };
     }, []);

     return (
          <div className="screen-saver">
               <div className="screen-saver-slider">
                    {imagesSrc.map((src, idx) => (
                         <div className="screen-saver-slide">
                              <CdnImage key={src} cloudName={cloudName} publicId={`app/pos/screensaver/${src}`} />
                         </div>
                    ))}
               </div>
          </div>
     );
};

export default memo(ScreenSaver);
